import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MetaHttpAdapter } from '@sp-core/http-adapters/meta-http-adapter';
import { ConsultHttpAdapter } from '@sp-core/http-adapters/consult-http-adapter';
import { map } from 'rxjs/operators';
import { HttpConsultService } from '../../http-services/http-consult/http-consult.service';
import { ITableService } from '@sp-shared/components/table';

@Injectable({
  providedIn: 'root',
})
export class ConsultUnassignedService implements ITableService<IConsult> {
  constructor(
    public readonly _httpConsultService: HttpConsultService,
    public readonly _consultHttpAdapter: ConsultHttpAdapter,
  ) {}

  public getTableData(params: HttpParamsOptions): Observable<ITableData<IConsult>> {
    return this._httpConsultService.getUnassignedConsult(params).pipe(
      map((response) => ({
        data: response.data.map((item) => this._consultHttpAdapter.transformToConsultData(item)),
        meta: MetaHttpAdapter.transformToMeta(response.meta),
      })),
    );
  }
}
